const routes = {
	guest: '/marketplace',
	gtm: '/gtm',
	about: '/about',
	login: '/login',
	loginRedirect: '/login/:path',
	signup: '/signup',
	forgetPasword: '/forget-password',
	resetPassword: '/reset-password',
	coreServices: '/services/core',
	coreServicesCreate: '/services/core/create',
	coreServicesEdit: '/services/core/edit/:packageId',
	more: '/more',
	editBusiness: 'business/edit/:businessId',
	404: '/404',
	services: '/services',
	cashbacklist: '/services/cashback/list',
	cashbackadd: '/services/cashback/add',
	cashbacksetting: '/services/cashback/setting',
	cashbackedit: '/services/cashback/edit/:id',
	couponRedemptionQr: '/coupon-redemption/qr-code',
	couponRedemptionOtherWay: '/coupon-redemption/other-way',
	couponRedemptionCancellation: '/coupon-redemption/usage',
	landingOffCb: '/services/offcb',
	landingCoreService: '/services/core-service',
	home: '/',
	dashboard: '/home',
	ticketsList: '/tickets',
	ticketsCreate: '/tickets/create',
	paymentRequest: '/payment-request',
	comments: '/comments',
	profileSetting: '/profile/setting',
	faq: '/faq',
	onboarding: '/onboarding',
	questionsAndAnswers: '/question-answer',
	notifications: '/notifications',
	reports: '/reports',
	core: '/reports/core',
	offcb: '/reports/offcb',
	TransactionsList: '/transactions/:type',
	advancedSearch: '/advanced-search',
	selectBusinessLine: '/selectBusinessLine',
	contract: '/contract',
	takhfifanPayContract: '/tkhpay-contract',
	offlineContracts: '/unauth-contract-vendor',
	tutorial: '/tutorial',
	offlineVendors: '/offlineVendors',
	signupBusiness: '/signupBusiness',
	signupSuccessful: '/signupSuccessful',
	priceList: '/price-list',
	walletTransaction: '/wallet-payment/transactions',
	factorAmount: '/wallet-payment',
	scanBarcode: '/wallet-payment/scan-barcode',
	manualBarcode: '/wallet-payment/manual-barcode',
	transactionStatus: '/wallet-payment/transactions-status',
};

export default routes;
